<template>
  <SwitchGroup as="div" class="flex items-center">
    <ToggleBase v-model="checked" @click="emit('click')" />
    <SwitchLabel as="span" class="ml-3">
      <SpanText size="text-sm" font="font-medium" color="text-gray-900">{{
        props.label
      }}</SpanText>
    </SwitchLabel>
  </SwitchGroup>
</template>

<script setup>
import ToggleBase from './ToggleBase.vue'
import { SwitchGroup, SwitchLabel } from '@headlessui/vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { computed } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  label: String,
})

const emit = defineEmits(['update:modelValue', 'click'])

const checked = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
